
import { Box, createTheme, CssBaseline, NoSsr, ThemeProvider } from "@mui/material";
import { mainController } from "@src/libs/mc/main/MainController";
import { AnimatePresence, motion } from "framer-motion";
import { AppProps } from "next/app";
import { useRouter } from "next/router";
import { Fragment, useEffect, useState } from "react";
import { Toaster } from 'react-hot-toast';

const theme = createTheme({
  typography: {
    button: {
      textTransform: 'none'
    }
  },
  colorSchemes: {
    dark: true,
  },
  palette: {
    mode: 'light',
  },
});



export default function AppContainer({ Component, pageProps }: AppProps) {
  const [initialized, setInitialized] = useState(false)
  const [loading, setLoading] = useState(false)
  const router = useRouter()
  useEffect(() => {
    if (initialized || loading) return
    setLoading(true)
    async function init() {
      // i18nInit()
      await mainController.init()
      setInitialized(true)
      setLoading(false);
    }
    init()
  }, [initialized, loading])
  return (

    <Fragment>
      <CssBaseline />
      <NoSsr>
        
          <ThemeProvider theme={theme}>
            <Box sx={{ padding: "5px" }} id={"mui-root-container"} maxWidth="lg" >
              {initialized ? <Component {...pageProps} /> : <Box>loading...</Box>}
              <Toaster />
            </Box>
          </ThemeProvider>
        
      </NoSsr>
    </Fragment>


  );
}